import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Offcanvas from "react-bootstrap/Offcanvas";
import "bootstrap/dist/css/bootstrap.css";
import ListIcon from "@mui/icons-material/List";
import Logo from "../../Images/Universal/PG Logo.svg";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import { Box } from "@mui/material";
import FollowUsOn from "../../Components/Follow Us On";


function Header() {


  const navLinks = [
    { name: "Home", link: "https://predictionguruji.org/" },
    { name: "About Us", link: "/about-us/" },
    { name: "Blogs", link: "/blogs" },
    { name: "Matches", link: "/live-score/series-list" }, {
      name: "Ranking",
      link: "/live-score/icc-rankings",
    },
  ];

  return (
    <>
      {["xl"].map((expand) => {
        return (
          <Navbar
            key={expand}
            expand={expand}
            className="bg-black header-nav pt-2"
          >
            <Container>
              <Link to="https://predictionguruji.org" className="header-logo p-0">
                <img src={Logo} className="md:w-[200px] w-[170px]" alt="logo" />
              </Link>

              {/* Offcanvas Toggle Button */}
              <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`}>
                <ListIcon style={{ color: "#fff", fontSize: "50px" }} />
              </Navbar.Toggle>

              <Navbar.Offcanvas
                id={`offcanvasNavbar-expand-${expand}`}
                aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
                placement="end"
              >
                <Offcanvas.Header closeButton style={{ backgroundColor: "#000" }}>
                  <Link
                    to="https://predictionguruji.org"
                    className="header-logo p-0"
                  >
                    <img
                      src={Logo}
                      className="w-[170px]"
                      alt="logo" />
                  </Link>
                </Offcanvas.Header>
                <Offcanvas.Body className="p-3">
                  <Nav className="flex flex-col w-full text-white items-center justify-start xl:justify-end">
                    {/* Tournaments Dropdown */}
                    {navLinks.map((item, index) => (
                      <Nav.Link href={item.link} key={index}>
                        {item.name}
                      </Nav.Link>
                    ))}
                    <Box className="ms-[5%]"><Nav.Link href="/contact-us"><Button className="gradient-golden-btn">Contact us</Button></Nav.Link></Box>
                    <Box className="d-sm-none w-100 mt-4">
                      <FollowUsOn />
                    </Box>
                  </Nav>

                </Offcanvas.Body>
              </Navbar.Offcanvas>
            </Container>
          </Navbar>
        );
      })}
    </>
  );
}

export default Header;
